import { useMutation } from '@apollo/client/react';
import { compact } from 'lodash-es';
import { toast } from 'react-toastify';

import { CookingStationName, FoodComponent, FoodComponentStationOperation } from '../libs';
import { BATCH_UPDATE_FOODS_PORTIONING_STATUS_V2_MUTATION, UPDATE_FOOD_COMPONENT_STATUS_MUTATION } from '../libs/graphQL';

interface UseFoodComponentStationActionProps {
  foodComponent: FoodComponent;
  tableName: CookingStationName;
  shortagesIds: string[];
  updatePortioningStatus: boolean;
}

const useFoodComponentStationAction = ({
  foodComponent,
  tableName,
  shortagesIds,
  updatePortioningStatus
}: UseFoodComponentStationActionProps) => {
  const [mutateFoodComponent, { loading }] = useMutation(UPDATE_FOOD_COMPONENT_STATUS_MUTATION);
  const [mutateFoodsPortioningStatus] = useMutation(BATCH_UPDATE_FOODS_PORTIONING_STATUS_V2_MUTATION);

  const handleFoodComponentStationAction = async (operation: FoodComponentStationOperation) => {
    await mutateFoodComponent({
      variables: {
        id: foodComponent.id,
        kitchen: foodComponent.kitchen,
        station: tableName,
        operation,
        shortagesIds
      },
      // eslint-disable-next-line @typescript-eslint/no-misused-promises -- Apollo ignores the return value; the unit test awaits it
      onCompleted: async () => {
        const lastStationName = foodComponent.cookingStations?.at(-1)?.name;
        if (lastStationName === tableName && operation === FoodComponentStationOperation.end && updatePortioningStatus) {
          try {
            await mutateFoodsPortioningStatus({
              variables: {
                kitchen: foodComponent.kitchen,
                foodsIds: compact(foodComponent.foodsIds ?? [])
              }
            });
          } catch (error) {
            console.error('Update portioning status error:', error);
            toast.error('Failed to update portioning status');
          }
        }
      },
      onError: (error) => {
        console.error('Update component station error:', error);
        toast.error('Failed to update the component status');
      }
      // Apollo 4 rejects the mutate promise even when onError handled the error.
    }).catch(() => undefined);
  };

  return { handleFoodComponentStationAction, loading };
};

export default useFoodComponentStationAction;
